var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMealCalculatorPlus = function SvgMealCalculatorPlus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 12,
    height: 4,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.97,
    y: 9,
    width: 3,
    height: 3,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 9,
    width: 3,
    height: 3,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 13,
    width: 3,
    height: 3,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 17,
    width: 3,
    height: 3,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 9,
    width: 3,
    height: 3,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.97,
    y: 13,
    width: 3,
    height: 3,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.97,
    y: 17,
    width: 3,
    height: 3,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.26,22H2a1,1,0,0,1-1-1V2A1,1,0,0,1,2,1H16a1,1,0,0,1,1,1v9.08A7,7,0,0,1,18,11V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V21a2,2,0,0,0,2,2H13.11A7,7,0,0,1,12.26,22Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm4,7H19v3H17V19H14V17h3V14h2v3h3Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMealCalculatorPlus);
export default ForwardRef;